import { loginReactUser, logoutReactUser } from "./api";

const STORAGE_KEY = "rbb_user";

export function setSession(user) {
  const payload = {
    username: user?.username || "",
    displayName: user?.displayName || user?.username || "",
    userId: user?.userId || "",
    roles: Array.isArray(user?.roles) ? user.roles : [],
    isAdmin: !!user?.isAdmin,
    mustChangePassword: !!user?.mustChangePassword,
    ts: Date.now(),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function clearSession() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function getSession() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!getSession();
}

export async function login(username, password) {
  if (!username || !password) {
    return { ok: false, message: "Username and password are required." };
  }

  try {
    const user = await loginReactUser(username, password);
    setSession(user);
    return { ok: true };
  } catch (err) {
    return { ok: false, message: err.message || "Invalid credentials." };
  }
}

export async function logout() {
  try {
    await logoutReactUser();
  } catch {
    // Ignore logout API errors and clear local session anyway.
  } finally {
    clearSession();
  }
}
